module.exports = __webpack_public_path__ + "img/Frente-51-01 on.b8853f0e.png";